import React from 'react';
import './App.css'
import { useState, useEffect } from "react";
import axios from 'axios';


interface pokemon {
    id: number
    name: string
    pokedex: string
}

function PokemonOfTheDay() {

  const [pokemonOfTheDay, setPokemonOfTheDay] = useState<pokemon | null>(null);
  const [dayOfYear, setDayOfYear] = useState(0);
  const [isLoading, setIsLoading] = useState<boolean>(true);



    useEffect(() => {
        const fetchPokemonOfTheDay = () => {
            var dayOfYear = calculateDayOfYear()
            axios
                .get('https://pokeapi.co/api/v2/pokemon-species/' + dayOfYear, {})
                .then((res) => {
                    setIsLoading(false)
                    console.log(res)
                    var newPokemonOfTheDay: pokemon = {
                        id: res.data.id,
                        name: res.data.name, 
                        pokedex: res.data.flavor_text_entries.filter((dexEntry: any) => dexEntry.language.name == "en")[0].flavor_text
                    }
                    setPokemonOfTheDay(newPokemonOfTheDay)
                })
        }

        const calculateDayOfYear = () => {
            var now = new Date();
            var start = new Date(now.getFullYear(), 0, 0);
            console.log(now.toDateString())
            var diff = ((now.getTime() - start.getTime()));
            var oneDay = 1000 * 60 * 60 * 24;
            var day = Math.floor(diff / oneDay);
            setDayOfYear(day)
            return day.toString();
        }

        fetchPokemonOfTheDay();
    }, [])

    if (isLoading) {
        return (<> Loading pokemon of the day </>)
    }
    return (
        <div className='center'>
            Today is the {dayOfYear.toString()}th day of the year.
            That means that {pokemonOfTheDay && pokemonOfTheDay.name} is the pokemon of the day!
            <br/>
            <i>{pokemonOfTheDay && pokemonOfTheDay.name}: {pokemonOfTheDay && pokemonOfTheDay.pokedex}</i>
        </div>
    )
}

export default PokemonOfTheDay;